var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KPage',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.load}},[_c('v-icon',[_vm._v("mdi-refresh")])],1)],1),_c('ServiceList',{ref:"services_list",attrs:{"status":_vm.$route.query.status,"next-days":_vm.$route.query.next_days,"show-construction":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }